import GenericDialog from "./generic";
import { deviceSet } from "api/device";
import { Device, DeviceSetBody } from "api/types/device";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setLoading } from "store/appSlice";
import DeviceGeneralForm, { DeviceGeneralFormType } from "widgets/forms/devices/general";
  
const DeviceInfoDialog = (props: {
  device: Device;
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}) => {
  const { device, isOpen, onClose, onSuccess } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const doDeviceSet = async (formData: DeviceGeneralFormType) => {
    const body: DeviceSetBody = {
      snr: device?.snr,
      meterNumber: formData.meterNumber,
      meterModel: formData.meterModel,
      host: formData.host,
      unitNumber: formData.unitNumber,
    };

    if (formData.siteId) {
      body.siteId = formData.siteId;
    }

    if (device?.model === "lte.opt") {
      body.iccid = formData.iccid ?? "";
    }

    dispatch(setLoading(true));
    const { status, isLoading } = await deviceSet(body);
    dispatch(setLoading(isLoading));

    if (status && status === 200) {
      onSuccess();
    }
  };

  return (
    <GenericDialog
      isOpen={isOpen}
      title={t("dialog.device.info.title.general")}
      onExit={onClose}
      size="lg"
    >
      <DeviceGeneralForm
        values={{
          meterNumber: device?.meterNumber || "",
          meterModel: device?.meterModel || "",
          host: device?.host || "",
          unitNumber: device?.unitNumber || "",
          siteId: device?.classes[0] || undefined,
          iccid: device?.iccid || "",
        }}
        showIccid={device?.model === "lte.opt"}
        submit={doDeviceSet}
        onClose={onClose}
      />
    </GenericDialog>
  );
};
  
export default DeviceInfoDialog;
  